var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileMinus = function SvgIconFileMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 13.25a1 1 0 1 0 0 2h4.5a1 1 0 1 0 0-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.5 20.25v-12a1 1 0 0 0-.293-.707l-5.25-5.25A1 1 0 0 0 14.25 2h-9A1.75 1.75 0 0 0 3.5 3.75v16.5A1.75 1.75 0 0 0 5.25 22h13.5a1.75 1.75 0 0 0 1.75-1.75M5.5 4v16h13V9.625h-4.625a1 1 0 0 1-1-1V4zm9.375 3.625h2.586l-2.586-2.586z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFileMinus;